import editIcon from "@/assets/icons/ic-edit-05.svg";

interface ChatHeaderProps {
  projectName: string;
  onEditName: () => void;
}

export function ChatHeader({ projectName, onEditName }: ChatHeaderProps) {
  return (
    <div className="flex items-center justify-center bg-[#EBEBEB] px-5 py-3 lg:px-[160px]">
      <div className="flex items-center gap-2">
        <h3 className="text-xl font-bold leading-6 tracking-[-0.018em] text-[#000000] lg:leading-7 lg:tracking-[-0.02em] whitespace-pre-line break-all">
          {projectName}
        </h3>
        <button type="button" onClick={onEditName} className="shrink-0">
          <img src={editIcon} alt="Edit" className="h-6 w-6" />
        </button>
      </div>
    </div>
  );
}
